


<section class="home-content grid-x">
  <div class="container temp-spacer">
    <div class="top-section">
      <H1 class="page-header">Admin</H1>
      @if (afAuth.user | async; as user) {
        <div>
          <h2>Hello {{ user.displayName }}!</h2>
          <button class="button" (click)="logout()">Logout</button>
          @if (!settings.published) {
            <button (click)="publish()" class="button">Publish Site</button>
          }
          @if (settings.published) {
            <button (click)="unPublish()" class="button">Un Publish Site</button>
          }
        </div>
      } @else {
        <button class="button" (click)="login()">Login with Google</button>
      }



    </div>
  </div>

</section>